import axios, { AxiosRequestConfig, AxiosResponse } from "axios";

import configs from "@/configs";
import apiHelper, { HelperConfig } from "./api.helper";
import { Api as SwaggerApiInstance } from "./swagger";
import { Api as PublicApi } from "./public.api";

// const baseURL = "https://tw.hunger.ai";
const baseURL =
  configs.REACT_APP_ENV === "development"
    ? "https://d2ob318ly2sjhj.cloudfront.net"
    : configs.REACT_APP_ENV === "pre-release"
    ? "https://pr-api.hotcakeapp.com"
    : "https://api-v3.hotcakeapp.com";

const api = axios.create({
  baseURL,
});

const publicAxiosInstance = axios.create({
  baseURL,
});

api.interceptors.request.use(apiHelper.handleRequest, (err) => {
  return Promise.reject(err);
});

api.interceptors.response.use(
  apiHelper.handleResponse,
  apiHelper.handleRequestError
);

const hungerAPI = {
  retry(config: HelperConfig): Promise<AxiosResponse> {
    return api(config);
  },

  get<T>(url: string, config?: AxiosRequestConfig): Promise<AxiosResponse<T>> {
    return new Promise<AxiosResponse<T>>(async (resolve, reject) => {
      try {
        const response = await api.get(url, config);
        resolve(response);
      } catch (error) {
        reject(error);
      }
    });
  },
  put<T>(
    url: string,
    data?: any,
    config?: AxiosRequestConfig
  ): Promise<AxiosResponse<T>> {
    return new Promise<AxiosResponse<T>>(async (resolve, reject) => {
      try {
        const response = await api.put(url, data, config);
        resolve(response);
      } catch (error) {
        reject(error);
      }
    });
  },
  post<T>(
    url: string,
    data?: any,
    config?: AxiosRequestConfig
  ): Promise<AxiosResponse<T>> {
    return new Promise<AxiosResponse<T>>(async (resolve, reject) => {
      try {
        const response = await api.post(url, data, config);
        resolve(response);
      } catch (error) {
        reject(error);
      }
    });
  },
  delete<T>(
    url: string,
    config?: AxiosRequestConfig
  ): Promise<AxiosResponse<T>> {
    return new Promise<AxiosResponse<T>>(async (resolve, reject) => {
      try {
        const response = await api.delete(url, config);
        resolve(response);
      } catch (error) {
        reject(error);
      }
    });
  },
};

const SwaggerInstance = new SwaggerApiInstance();
SwaggerInstance.instance = api;

const publicApi = new PublicApi();
publicApi.instance = publicAxiosInstance;

export const SwaggerAPI = SwaggerInstance.api;
export default hungerAPI;
export { publicApi };
